import type { Middleware } from "@reduxjs/toolkit";
import { showNotificationMessage } from "../modules/uiState";

type RejectionPayload = {
  messageId?: string;
  code?: string;
  message?: string;
  values?: Record<string, any>;
};

// Middleware: generic notifications for all rejected thunks with structured payloads
export const rejectionNotificationMiddleware: Middleware =
  (storeAPI) => (next) => (action: any) => {
    // Only react to RTK rejections
    if (typeof action.type === "string" && action.type.endsWith("/rejected")) {
      const { payload, error } = action;

      // Only handle if the thunk used rejectWithValue (i.e., has a payload)
      if (payload) {
        const typedPayload = payload as RejectionPayload;

        // Best-effort extraction of message id and fallback message
        const messageId =
          typedPayload.messageId ||
          (typedPayload.code ? `ErrorMessage.${typedPayload.code}` : undefined);
        const fallbackMessage =
          typedPayload.message || error?.message || "Unexpected error";
        const values = typedPayload.values;

        storeAPI.dispatch(
          showNotificationMessage({
            messageId,
            message: fallbackMessage,
            values,
          }) as any,
        );
      }
    }

    return next(action);
  };
